@if (isLoggedIn) {
  <div class="tabs fixed-bottom d-block d-lg-none px-2 px-lg-4" id="tabbar">
    <div role="navigation" class="row flex-nowrap align-items-center h-100 gx-2 gx-xs-3">
      <div class="col">
        <a (click)="closeProfile()" [ngClass]="{ active: isProductPath }" [routerLink]="productsRoute" class="tabs-item text-focus-ring">
          <div class="tabs-item-icon">
            <i class="fas fa-box"></i>
          </div>
          <p translate="global.navbar.products"></p>
        </a>
      </div>
      @if (config.goodies.isRouteEnabled) {
        <div class="col">
          <a (click)="closeProfile()" [ngClass]="{ active: isGoodiePath }" [routerLink]="goodieRoute" class="tabs-item text-focus-ring">
            <div class="tabs-item-icon">
              <i class="fas fa-gift"></i>
            </div>
            <p translate="global.navbar.goodies"></p>
          </a>
        </div>
      }
      <div class="col">
        <a
          (click)="toggleProfile()"
          href="javascript:;"
          [ngClass]="{ 'profile-active': isProfileOpen(), active: isProfilePath }"
          class="tabs-item text-focus-ring"
        >
          <div class="tabs-item-icon">
            <i class="fas {{ config.profile.menuIconClass }}"></i>
          </div>
          <p translate="global.navbar.profile"></p>
        </a>
        <div class="tabs-submenu">
          <div class="card-basic text-start">
            <div class="card-basic-body card-basic-segment p-3">
              <div class="mb-3">
                <div
                  class="bg-primary text-white rounded-pill d-inline-flex align-items-center justify-content-center"
                  style="width: 2rem; height: 2rem"
                >
                  <i [ngClass]="config.profile.menuIconClass" class="fas"></i>
                </div>
              </div>
              <div class="text-secondary text-break fw-bold mb-1">{{ userName() }}</div>
              <p class="text-body">{{ emailAddress() }}</p>
              <mwe-badge [text]="config.profile.menuTagNameLabel" type="info" emphasis="bold" size="md" />
            </div>
            <div class="card-basic-body card-basic-segment p-3">
              <div class="mb-3">
                <a
                  (click)="closeProfile()"
                  [routerLink]="profileRoute"
                  class="text-secondary link-active-opacity text-focus-ring"
                  routerLinkActive="active"
                  translate="global.navbar.profileSubMenu.profileLinkText"
                ></a>
              </div>
              <div>
                <a
                  href="javascript:;"
                  (click)="closeProfile(); switchPortal()"
                  [translate]="config.profile.portalSwitchRouteLabel"
                  class="text-secondary link-active-opacity text-focus-ring pointer"
                  routerLinkActive="active"
                ></a>
              </div>
            </div>
            <div class="card-basic-body card-basic-segment mb-9 p-3">
              <div>
                <a
                  (click)="closeProfile(); logout()"
                  (keyup.enter)="closeProfile(); logout()"
                  class="text-secondary link-active-opacity text-focus-ring"
                  tabindex="0"
                >
                  <i class="fas fa-sign-out"></i>
                  {{ 'global.navbar.profileSubMenu.logoutLinkText' | translate }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
